import { getFormattedPageNumber, timeToStandard } from '@frameio/utils/media';
import type { AssetThumbnailFragment } from '../gql/generated/AssetThumbnail';

/**
 * The getDuration function returns the duration of the asset for VideoAsset or AudioAsset types, or the number of pages for DocumentAsset type.
 * @param data The AssetThumbnailFragment instance
 * @returns a string representing the duration or the number of pages
 */
export const getDuration = (data: AssetThumbnailFragment) => {
  if (data.__typename === 'DocumentAsset' && data.media) {
    return getFormattedPageNumber(data.media.pageCount ?? 0);
  }
  if (
    (data.__typename === 'VideoAsset' ||
      data.__typename === 'AudioAsset' ||
      data.__typename === 'ModelAsset') &&
    data.media?.duration
  ) {
    return timeToStandard(data.media.duration);
  }
  return undefined;
};
